import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import PlayIconOverlay from './PlayIconOverlay'
import YouTubeModal from './YouTubeModal'
// import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component'

class GalleryView extends Component {

  state = { youtubeModalUrl: null }

  componentDidMount() {
    window.scrollTo(0,0)
  }

  render() {
    const gallery = this.props.galleries.find(gal => gal._id === this.props.match.params.galleryID)
    if (!gallery && this.props.galleries.length) return <div>Gallery not found.</div>
    if (!this.props.galleries.length) return <div>Loading...</div>
    // const scrollPosition = this.props.scrollPosition
    return (
      <div>
        <div><Link to='/'>HOME</Link></div>
        <h1>{gallery.title}</h1>
        <div className="home-gallery-images-wrapper gallery-images-wrapper">
          { gallery.images.map(image => {
            const fileNameAsUrl = image.fileName.split('.')[0]
            return (
              <div className="home-gallery-image-wrapper gallery-image-wrapper" key={image._id}>
                {image.youtubeUrl ? (
                  <PlayIconOverlay onClick={() => this.setState({ youtubeModalUrl: image.youtubeUrl })}>
                    <Link to={`/image/${fileNameAsUrl}`} >
                      <img
                        src={`/api/images/${image.fileName}?galleryview=500`}
                        className="home-gallery-image"
                        alt={image.title}
                      />
                    </Link>
                  </PlayIconOverlay>
                ) : (
                  <Link to={`/image/${fileNameAsUrl}`} >
                    <img
                      src={`/api/images/${image.fileName}?galleryview=500`}
                      className="home-gallery-image"
                      alt={image.title}
                    />
                  {/* <LazyLoadImage
                  scrollPosition={scrollPosition}
                    src={`/api/images/${image.fileName}?galleryview=500`}
                    className="home-gallery-image"
                  /> */}
                  </Link>
                )}
              </div>
            )

          })}
        </div>
        {this.state.youtubeModalUrl && (
          <YouTubeModal
            youtubeUrl={this.state.youtubeModalUrl}
            onClose={() => this.setState({ youtubeModalUrl: null })}
          />
        )}
      </div>
    )
  }
}

// export default trackWindowScroll(GalleryView)
export default GalleryView
